import ViewWaterMeter from './view_meter';
import AddMeter from './add_meter'
import AssignWaterMeter from './assign_meter';
import WaterMeters from './meters'
import WaterConfigs from './configs'
import Concentrators from './concentrators'
import AddConcentrator from './add_new_concentrator'
import PostDeliveryReport  from './delivery_report'
import Deliveries  from './deliveries'
import MeterDeliveryNote  from './delivery_note'
import WaterMeterManagement  from './meter_reports'
import MeterReports  from './meter_reports'
import AccountsReports  from './accounts'
import TransactionsReports  from './transactions'

const waterMeterManagementRoutes = [
    {
        path: "/core/water_meter_management/concentrators",
        element: <Concentrators />
    },
    {
        path: "/core/water_meter_management/add_new_concentrator",
        element: <AddConcentrator />
    },
    {
        path: "/core/water_meter_management/meters",
        element: <WaterMeters />
    },
    {
        path: "/core/water_meter_management/add_new_meter",
        element: <AddMeter />
    },
    {
        path: "/core/water_meter_management/view_meter",
        element: <ViewWaterMeter />
    },
    {
        path: "/core/water_meter_management/assign",
        element: <AssignWaterMeter />

    },
    {
        path: "/core/water_meter_management/configs",
        element: <WaterConfigs />

    },
    {
        path: "/core/water_meter_management/post_delivery_report",
        element: <PostDeliveryReport/>

    },
    {
        path: "/core/water_meter_management/deliveries",
        element: <Deliveries/>

    },
    {
        path: "/core/water_meter_management/delivery_note",
        element: <MeterDeliveryNote/>

    },
     {
        path: "/core/water_meter_management/meter_reports",
        element: <WaterMeterManagement/>

    },
     {
        path: "/core/water_meter_management/meter_reports",
        element: <MeterReports/>

    },
     {
        path: "/core/water_meter_management/customer_reports",
        element: <AccountsReports/>

    },
     {
        path: "/core/water_meter_management/transactions_reports",
        element: <TransactionsReports/>

    }

]
export default waterMeterManagementRoutes